import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  BALANCES_DOWNLOAD_REPORT_MUTATION_KEY,
  BALANCES_DOWNLOAD_REPORT_URL,
  BALANCES_PERMISSIONS,
} from '../constants';

export default function useDownloadBalancesReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [BALANCES_DOWNLOAD_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      BALANCES_DOWNLOAD_REPORT_URL,
      payload,
      { permission: BALANCES_PERMISSIONS.DOWNLOAD_LIST },
    ),
  });
}
